import { ContactForm } from "./ContactForm";

interface EmailChatBodyProps {
  showContactForm: boolean;
  contactFormSubmitted: boolean;
  config: any;
  formValues: Record<string, string>;
  setFormValues: (v: Record<string, string>) => void;
  submitForm: (e: React.FormEvent) => void;
  submitting: boolean;
  formError: string | null;
  detectedCountry?: any;
  invalidPhoneField?: string;
}

export function EmailChatBody({
  showContactForm,
  contactFormSubmitted,
  config,
  formValues,
  setFormValues,
  submitForm,
  submitting,
  formError,
  detectedCountry,
  invalidPhoneField,
}: EmailChatBodyProps) {
  if (contactFormSubmitted) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-3 p-6 text-center">
        <p className="text-sm font-semibold">Thanks — your message is in.</p>
        <p className="text-xs text-muted-foreground">
          Someone on the team will get back to you by text or email during business hours (11
          am–7 pm).
        </p>
      </div>
    );
  }
  if (!showContactForm) return null;
  return (
    <ContactForm
      config={config}
      formValues={formValues}
      setFormValues={setFormValues}
      submitForm={submitForm}
      submitting={submitting}
      formError={formError}
      detectedCountry={detectedCountry}
      invalidPhoneField={invalidPhoneField}
    />
  );
}
